const strings = {
  usersPage: {
    modal: {
      addUser: "Add User",
      deleteUser: "Delete User",
      description:
        "New users will receive an email with sign in instructions. Added Users will be able to sign in and access the Herba Dashboard and settings.",
      deleteDescription:
        "Deleting a user will remove them from the system. Are you sure? Type DELETE in the field below to confirm.",
      deletePendingDescription:
        "Deleting this user will revoke their invitation. Are you sure? Type DELETE in the field below to confirm.",
      firstNameLabel: "FIRST NAME*",
      firstNamePlaceholder: "First Name",
      firstNameRequired: "First Name is required",

      lastNameLabel: "LAST NAME*",
      lastNamePlaceholder: "Last Name",
      lastNameRequired: "Last Name is required",

      emailLabel: "EMAIL*",
      emailPlaceholder: "Email address",
      invalidEmail: "Please enter a valid email address",
      successTitle: "User Added",

      deleteMePlaceholder: "Type DELETE to confirm",

      successMessage: (name: string) =>
        `${name} was added, they will receive an email confirmation and now be able to Sign In.`,
      removeTitle: "User Removed",
      removeMessage: (name: string) =>
        `${name} will no longer have access to Herba. If this was a mistake, add them again by pressing the Add New User button.`,
    },
    removeUser: "Remove User",
    addNewUser: "ADD NEW USER",
    invitePending: "Invite Pending - Awaiting User Acceptance",

    reachedMaxUser: "You have reached the maximum number of users",
    addMoreUserDescription: (usersLeft: number) =>
      `You can add up to ${usersLeft} more users`,
    addUserDescription: "You can add one more user",
  },
};

export default strings;
